import { WidgetComponentType } from "models/screenshot";

import { useScreenshotContext } from "components/screenshot/hooks";
import { ParentDimensionsT } from "components/shared/charts/legend/Legend";

import { useIpdbStore } from "../contexts/IpdbStoreProvider";
import { selectShowIpdb } from "../contexts/ipdbSelectors";
import { IPDBLegendBase } from "../shared/IPDBLegendBase";

export type IpdbLegendT = {
  height?: number;
  width?: number;
  parentDimensions: ParentDimensionsT;
  ipdbTitleSize?: number;
  ipdbFontSize?: number;
  backgroundOpacity?: number;
  showLegendBorder?: boolean;
  location: "map" | "xda";
};

export const IpdbLegend: React.FC<IpdbLegendT> = ({
  width = 180,
  height = 250,
  parentDimensions = undefined,
  ipdbTitleSize = undefined,
  ipdbFontSize = undefined,
  backgroundOpacity = undefined,
  showLegendBorder = undefined,
  location = "map"
}) => {
  // Hooks
  const { widget } = useScreenshotContext();
  const showIpdb = useIpdbStore(selectShowIpdb);
  // In dashboard screenshot mode, keep the legend visible (widget type is "dashboard")
  const isMapScreenshotActive = widget?.widgetComponentType === WidgetComponentType.Map;
  return (
    <IPDBLegendBase
      width={width}
      height={height}
      parentDimensions={parentDimensions}
      dimensionsStorageKey={
        location === "map" ? `map-ipdb-legend-dimensions` : `xda-ipdb-legend-dimensions`
      }
      positionStorageKey={
        location === "map" ? `map-ipdb-legend-position` : `xda-ipdb-legend-position`
      }
      parentDimensionsStorageKey={
        location === "map" ? `map-ipdb-parent-dimensions` : `xda-ipdb-parent-dimensions`
      }
      showLegend={location === "map" ? showIpdb && !isMapScreenshotActive : true}
      ipdbTitleSize={
        ipdbTitleSize !== undefined ? ipdbTitleSize : Number(ipdbFontSize) + 1
      }
      ipdbLabelsSize={ipdbFontSize}
      backgroundOpacity={backgroundOpacity}
      showLegendBorder={showLegendBorder}
    />
  );
};
